import { Component, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'
import { GlobalConstants } from 'src/app/constants/global-constants'
import { DynamicComponentLoaderService } from 'src/app/services/dynamic-component-loader/dynamic-component-loader.service'
import { start_logout } from 'src/app/store/action/auth.action'
import { AppState } from 'src/app/store/state/app.state'
import { getSelectedCompaniesFromState } from 'src/app/store/selector/initialize.selector'
import { Subscription } from 'rxjs'
import { SelectedCompanyAPIModel } from 'src/app/models/api.model'

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  readonly DASHBOARD = `/${GlobalConstants.ROUTING.DASHBOARD}`
  readonly SETTINGS = `/${GlobalConstants.ROUTING.SETTINGS}`

  companyName = null
  selectedCompaniesSubscription: Subscription
  selectedCompanies: SelectedCompanyAPIModel[]

  constructor(
    private appState: Store<AppState>,
    private dynamicComponentLoaderService: DynamicComponentLoaderService
  ) {}

  ngOnInit(): void {
    this.selectedCompaniesSubscription = this.appState
      .select(getSelectedCompaniesFromState)
      .subscribe(selectedCompanies => {
        if (selectedCompanies) {
          this.companyName = selectedCompanies?.filter(sc => sc?.showOnUIHeader)?.[0]?.name
          this.selectedCompanies = selectedCompanies
        }
      })
  }

  logout() {
    this.appState.dispatch(start_logout({}))
  }

  openClientSelector() {
    this.dynamicComponentLoaderService.loadComponent(GlobalConstants.DYNAMIC_MODEL.CLIENT_SELECTOR.key)
  }

  ngOnDestroy() {
    this.selectedCompaniesSubscription?.unsubscribe()
  }
}
